import { ADMIN_DASHBOARD_PATH } from "../router/Admin/AdminRoutes";
import { INSTITUTION_ADMIN_DASHBOARD_PATH } from "../router/Institution/InstitutionRoutes";

export const USER_ROLES = {
  ADMIN: "Administrator",
  INSTITUTION_ADMIN: "Institution Administrator",
  OTHER_ADMINISTRATOR: "Other Administrator",
};

export const getDashboardPathForRole = (role) => {
  if (!role) return "/";
  const normalized = role.trim().toLowerCase();

  const roleMap = {
    [USER_ROLES.ADMIN.toLowerCase()]: ADMIN_DASHBOARD_PATH,
    [USER_ROLES.OTHER_ADMINISTRATOR.toLowerCase()]: ADMIN_DASHBOARD_PATH,
    [USER_ROLES.INSTITUTION_ADMIN.toLowerCase()]:
      INSTITUTION_ADMIN_DASHBOARD_PATH,
  };

  return roleMap[normalized] || "/";
};
